import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
const subLotControllerEndpoint = 'SubLotCreationL2';


export class UsedRentalsSubLotAPI {
  params;

  getSubLotById(ruL2Id) {
    return axios.get(getBackendURL() + subLotControllerEndpoint + '/GetRUSubLotById?ruL2Id=' + ruL2Id);
  }

  createSubLot(dto) {
    return axios.post(getBackendURL() + subLotControllerEndpoint + '/CreateRUSubLot', dto);
  }

  updateSubLot(dto) {
    return axios.put(getBackendURL() + subLotControllerEndpoint + '/EditRUSubLot', dto);
  }

  deleteSubLot(ruL2Id) {
    return axios.delete(getBackendURL() + subLotControllerEndpoint + '/DeleteRUSubLot?ruL2Id=' + ruL2Id);
  }

  cloneSubLot(ruL2Id) {
    return axios.put(getBackendURL() + subLotControllerEndpoint + '/CloneRUSubLot?ruL2Id=' + ruL2Id);
  }

  updateAgendamentoNumRefL2(dto) {
    return axios.put(getBackendURL() + subLotControllerEndpoint + '/UpdateAgendamentoNumRefL2', dto);
  }
}

export default UsedRentalsSubLotAPI


// WEBPACK FOOTER //
// ./src/API/UsedRentalsSubLotsAPI.js